import { LOGIN_LAYOUT_IMAGE, ROMA_LOGO_WHITE, ZAMP_LOGO_WHITE } from 'constants/icons';
import Image from 'next/image';
import { isRomaDashboard } from 'utils/common';

export interface LoginLayoutProps {
  children: React.ReactNode;
  isTransition?: boolean;
}

const LoginLayout = (props: LoginLayoutProps) => {
  const isRoma = isRomaDashboard();

  return (
    <div data-testid='login-layout-container' className='tw-w-screen tw-h-screen tw-flex tw-text-TEXT_GRAY_1'>
      <div
        data-testid='login-layout-child-wrapper'
        className='md:tw-rounded-r-lg tw-bg-white tw-drop-shadow-md tw-max-w-full md:tw-max-w-[612px] tw-w-full tw-px-6 md:tw-px-12'
      >
        {props.children}
      </div>
      <div
        data-testid='login-layout-image-container'
        className='tw-absolute tw-top-0 tw-right-0 tw-h-screen tw-w-[calc(100%-544px)] -tw-z-10'
      >
        <div data-testid='login-layout-logo-wrapper' className='tw-absolute tw-top-9 tw-right-9 tw-z-10 tw-w-32'>
          <Image src={isRoma ? ROMA_LOGO_WHITE : ZAMP_LOGO_WHITE} alt='Zamp logo' width='114' height='28' />
        </div>

        <Image src={LOGIN_LAYOUT_IMAGE} alt={'login-illustration'} fill={true} priority className='tw-object-cover' />
      </div>
    </div>
  );
};

export default LoginLayout;
